import { type Product } from "~/api/products/types";
import { getKioskProductQuantity } from "~/stores/kiosk-session/hooks/use-kiosk-product-basket";
import { type BasketItem } from "~/stores/kiosk-session/types";

export type UnmetOrderMinimum = {
  id: string;
  name: string;
  orderMin: number;
  quantity: number;
};

type GetUnmetOrderMinimumsArgs = {
  basket: BasketItem[];
  products: Pick<Product, "id" | "name" | "orderMin">[];
};

/** Products in the basket whose quantity, summed over every line, is below their per-order minimum. */
export function getUnmetOrderMinimums({
  basket,
  products
}: GetUnmetOrderMinimumsArgs): UnmetOrderMinimum[] {
  return products.flatMap((product) => {
    if (product.orderMin === null) return [];

    const quantity = getKioskProductQuantity(basket, product.id);
    if (quantity === 0 || quantity >= product.orderMin) return [];

    return [
      {
        id: product.id,
        name: product.name,
        orderMin: product.orderMin,
        quantity
      }
    ];
  });
}
